// core components
import Header from "components/Headers/Header.js";
import DynamicTable from "./DynamicTables";
import { get, put } from "utils/api";
import { filterData } from "utils/helperFunction";
import { useEffect, useState } from "react";
import { useSearch } from "views/Contexts/SearchContext";
import Dropdown from "components/DropDown/Dropdown";
import { useNavigate } from "react-router-dom";

const Tenant = () => {
  const [tenants, setTenants] = useState([]);
  const navigator = useNavigate();
  const [totalData, setTotaldata] = useState(null);
  const { searchQuery, loading, setLoading } = useSearch();
  const options = ["active", "suspended", "locked", "inactive"];
  const [selectedOption, setSelectedOption] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [data, setData] = useState(tenants);
  const [allowedSortFields] = useState([
    "first_name",
    "last_name",
    "phone_number",
    "email",
  ]);

  const showData = [
    "id",
    "first_name",
    "last_name",
    "phone_number",
    "email",
    "status",
  ];
  const api = async () => {
    setLoading(true);
    get("/api/user/get-list-by-admin/tenant", dataList)
      .then((response) => {
        setTenants(filterData(showData, response?.data?.rows));
        setTotaldata(response?.data?.count);
        setData(tenants);
        setLoading(false);
      })
      .catch((error) => {
        // console.log(error);
        setLoading(false);
      });
  };
  const clickOnViewMore = (e) => {
    // console.log("click on view more button ", e.target.value);
    navigator(`/user/tenant/${e.target.value}`);
  };
  const clickOnOrderHistory = (e) => {
    let userId = e.target.value;
    let queryParams = new URLSearchParams();
    queryParams.set("userId", userId);
    queryParams.set("role", "tenant");
    let queryString = queryParams.toString();
    navigator(`/user/order?${queryString}`, {
      state: { currentService: false },
    });
  };
  const clickOnRunningSerice = (e) => {
    // console.log("click on Running service ", e.target.value);
    let queryParams = new URLSearchParams();
    let userId = e.target.value;
    queryParams.set("userId", userId);
    queryParams.set("role", "tenant");
    let queryString = queryParams.toString();
    navigator(`/user/order?${queryString}`, {
      state: { currentService: true },
    });
  };
  const clickOnPakageInfomation = (e) => {
    // console.log("click on Pakage info", e.target.value);
  };
  const clickOnActiveDeactive = (e) => {
    setLoading(true);
    put("/api/user/update-account-status", {
      user_id: e.target.value,
      status: e.target.dataset.key,
    })
      .then((res) => {
        // console.log(res);
        if (res.statusCode === 200) {
          api();
          setData(tenants);
          setLoading(false);
        }
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
      });
  };
  let dataList = {};
  if (pageNo) {
    dataList.page = pageNo;
  }
  if (searchQuery) {
    dataList.name = searchQuery;
  }
  useEffect(() => {
    setData(tenants);
  }, [tenants]);

  useEffect(() => {
    api();
    // eslint-disable-next-line
  }, [pageNo, searchQuery]);

  return (
    <>
      <Header />
      {data && data.length > 0 ? (
        <DynamicTable
          data={data}
          setData={setData}
          listName={"Tenant List"}
          clickOnViewMore={clickOnViewMore}
          clickOnOrderHistory={clickOnOrderHistory}
          clickOnRunningSerice={clickOnRunningSerice}
          clickOnPakageInfomation={clickOnPakageInfomation}
          clickOnActiveDeactive={clickOnActiveDeactive}
          allowedSortFields={allowedSortFields}
          totalData={totalData}
          setPageNo={setPageNo}
          loading={loading}
          pageNo={pageNo}
          options={options}
          dropdown={
            <Dropdown
              options={options}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
            />
          }
        />
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "40%" }}
        >
          {loading ? (
            <div className="spinner-border text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <p>No data available</p> // Show when not loading and no data found
          )}
        </div>
      )}
    </>
  );
};

export default Tenant;
